import React, { useState, useEffect } from "react";
import "./club.css";
import axios from "axios";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { APIURL } from "../../Global";

const Club = ({ date, reload }) => {
    const [nurses, setNurses] = useState([]); // List of all nurses
    const [leaveData, setLeaveData] = useState([]); // Leave data fetched from API
    const [viewDays, setViewDays] = useState(7);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null); // State for end date

    const leaveTypes = {
        Work: { label: "W", color: "#d4edda" },
        week_off: { label: "O", color: "#f8d7da" },
    };

    // Update end date whenever startDate or viewDays changes
    useEffect(() => {
        const calculateEndDate = (start, days) => {
            const end = new Date(start);
            end.setDate(start.getDate() + days - 1); // Subtract 1 to include the start date
            return end.toISOString().split("T")[0];
        };
        setEndDate(calculateEndDate(startDate, viewDays));
    }, [startDate, viewDays]);

    // Fetch all nurses
    useEffect(() => {
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString?.replace(/["]+/g, "");

        if (!token) return;

        const headers = { Authorization: "Token " + token };

        axios
            .get(`${APIURL}/api/v1/service-provider/nurse/`, { headers })
            .then((res) => {
                if (res.status === 200) {
                    const filteredNurses = res.data.filter((nurse) => nurse.username);
                    setNurses(filteredNurses);
                }
            })
            .catch(() => {
                console.error("Error fetching nurses");
            });
    }, []);

    // Fetch leave data whenever startDate or endDate changes
    useEffect(() => {
        if (!endDate) return; // Wait until endDate is calculated
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString?.replace(/["]+/g, "");

        if (!token) return;

        const start = startDate.toISOString().split("T")[0];

        axios
            .get(
                `${APIURL}/api/v1/service-provider/nurse-total-leave/?start_date=${start}&end_date=${endDate}`,
                { headers: { Authorization: "Token " + token } }
            )
            .then((res) => {
                if (res.data.status === "success") {
                    setLeaveData(res.data.leaves);
                } else {
                    setLeaveData([]);
                }
            })
            .catch(() => {
                console.error("Error fetching leave data");
            });
    }, [endDate, reload]);

    // Navigate between weeks or months
    const navigateDays = (direction) => {
        const newStartDate = new Date(startDate);
        newStartDate.setDate(newStartDate.getDate() + direction * viewDays);
        setStartDate(newStartDate);
    };

    // Generate the array of dates to be displayed based on the viewDays
    const getViewDays = () => {
        const viewDates = [];
        const currentDate = new Date(startDate);
        for (let i = 0; i < viewDays; i++) {
            const dateKey = currentDate.toISOString().split("T")[0];
            const dayShort = currentDate.toLocaleDateString("en-US", { weekday: "short" });
            viewDates.push({ date: dateKey, dayShort });
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return viewDates;
    };

    // Combine nurses and leave data
    const getLeaveDataForNurse = (nurse) => {
        const nurseLeaveData = leaveData.find((leave) => leave.nurse === nurse.name);
        const leaveDays = nurseLeaveData?.leave_days || [];
        return getViewDays().map(({ date }) => {
            const leave = leaveDays.find((leave) => leave.date === date);
            return leave ? leave.leave_type : "Work"; // Default to "Work" if no leave
        });
    };

    // Get short label and background color for the leave type
    const getLeaveStyle = (leaveType) => {
        const leave = leaveTypes[leaveType] || { label: 'L', color: "#e6817a" }; // Default to "L" if unknown leave type
        return {
            backgroundColor: leave.color,
            color: "#000",
            padding: "5px",
            textAlign: "center"
        };
    };

    return (
        <div className="club-container">
            {/* View toggle for Weekly/Monthly */}
            <div className="view-toggle" style={{ display: "flex", alignItems: "center" }}>
                <button
                    onClick={() => setViewDays(7)}
                    style={{ backgroundColor: viewDays === 7 ? "#2456AE" : "", color: viewDays === 7 ? "#fff" : "" }}
                >
                    Weekly View
                </button>
                <button
                    onClick={() => setViewDays(28)}
                    style={{ backgroundColor: viewDays === 28 ? "#2456AE" : "", color: viewDays === 28 ? "#fff" : "" }}
                >
                    Monthly View
                </button>
                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
                    <FaChevronLeft style={{ cursor: "pointer" }} onClick={() => navigateDays(-1)} />
                    <FaChevronRight style={{ cursor: "pointer" }} onClick={() => navigateDays(1)} />
                </div>
            </div>

            <table className="club-table">
                <thead>
                    <tr>
                        <th>NURSE</th>
                        {getViewDays().map(({ date, dayShort }) => (
                            <th key={date}>
                                <div className="date-day" style={{ display: "flex", flexDirection: "column" }}>
                                    <span>{date}</span>
                                    <span style={{ fontSize: "0.8em" }}>{dayShort}</span>
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {nurses.map((nurse) => (
                        <tr key={nurse.name}>
                            <td style={{ textTransform: 'capitalize', textAlign: 'left', paddingLeft: '10px' }}>
                                {nurse.name}
                            </td>
                            {getLeaveDataForNurse(nurse).map((leaveType, index) => {
                                const leaveStyle = getLeaveStyle(leaveType); // Get the style for this leave type
                                return (
                                    <td key={`${nurse.name}-${index}`} style={leaveStyle}>
                                        {leaveTypes[leaveType] ? leaveTypes[leaveType].label : "L"}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Club;
